import { render } from "./BroadcastView.vue?vue&type=template&id=72bbd4f4"
import script from "./BroadcastView.vue?vue&type=script&lang=js"
export * from "./BroadcastView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__